export type GachaRevealRarity = "common" | "rare" | "legendary"

export type GachaRevealCardPayload = {
  name: string
  sub: string
  image: string
  imageBack: string
  grade: string
  rarity: GachaRevealRarity
  stats: { label: string; value: string }[]
  pack?: string
}

type GachaRevealPullResult = {
  itemName: string
  collectionName?: string
  frontImageUrl: string
  backImageUrl?: string
  grade: string
  marketValue: string
}

function gradeToRarity(grade: string): GachaRevealRarity {
  const normalized = grade.toLowerCase()

  if (
    normalized.includes("epic") ||
    normalized.includes("legendary") ||
    normalized.includes("grail") ||
    normalized.includes("pristine") ||
    normalized.includes("gem-mt") ||
    normalized.includes("gem mt") ||
    /\b(psa|bgs|beckett|cgc)\s*10\b/.test(normalized) ||
    normalized.includes("gem mint")
  ) {
    return "legendary"
  }

  if (
    normalized.includes("rare") ||
    normalized.includes("holo") ||
    normalized.includes("nm-mt") ||
    normalized.includes("mint 9") ||
    /\b(psa|bgs|beckett|cgc)\s*9(\.5)?\b/.test(normalized)
  ) {
    return "rare"
  }

  return "common"
}

export function pullResultToRevealCard(
  pullResult: GachaRevealPullResult,
  options?: { packUrl?: string; sub?: string },
): GachaRevealCardPayload {
  return {
    name: pullResult.itemName,
    sub: options?.sub ?? pullResult.collectionName ?? pullResult.grade,
    image: pullResult.frontImageUrl,
    imageBack: pullResult.backImageUrl || pullResult.frontImageUrl,
    grade: pullResult.grade.toUpperCase(),
    rarity: gradeToRarity(pullResult.grade),
    stats: [
      { label: "GRADE", value: pullResult.grade },
      { label: "VALUE", value: pullResult.marketValue },
    ],
    pack: options?.packUrl,
  }
}
